/* @refresh reload */
import '@forest/shared/polyfills'

import { bootstrapEntitlement } from './setup'

import './index.css'

import { QueryClientProvider } from '@tanstack/solid-query'
import { render } from 'solid-js/web'
import { App } from './app'
import { shouldMockAPI } from './lib/params'
import { queryClient } from './lib/query-client'

console.log('all modules imported')

async function enableMocking() {
  const { worker, installNativeMocks } = await import('./mocks')
  installNativeMocks()
  return worker.start({ onUnhandledRequest: 'bypass' })
}

function renderApp() {
  render(
    () => (
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    ),
    document.getElementById('root')!,
  )
}

async function boot() {
  if (import.meta.env.DEV && shouldMockAPI) {
    await enableMocking()
  }
  renderApp()
  // Fire-and-forget: entitlement-gated UI shows skeletons via
  // $serviceLevelReady until this resolves.
  void bootstrapEntitlement()
}

boot()
